import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteTransmittalActions'
import * as api from '../../api/job/jobSiteTransmittals'

function* jobSiteTransmittalsRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteTransmittals, action.jobId)
    yield put({ type: constants.JOB_SITE_TRANSMITTALS_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_TRANSMITTALS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteTransmittals() {
  yield takeLatest(constants.JOB_SITE_TRANSMITTALS_REFRESH.ACTION, jobSiteTransmittalsRefresh)
}

function* sagaCreateJobSiteTransmittal(action) {
  try {
    const payload = {
      transmittal_data: {
        description: action.content.description,
        attention: action.content.attention,
        organization_id: action.content.organization_id,
        job_id: action.jobId,
        created_by_id: action.userId,
        updated_by_id: action.userId,
        sending_other_text: action.content.sending_other_text,
        transmitted_other_text: action.content.transmitted_other_text
      },
      sending_list: action.sending,
      transmittal_items: action.transmittalItems,
      transmitted_list: action.transmitted
    }
    yield call(api.createJobSiteTransmittal, payload)
    yield put({ type: constants.JOB_SITE_TRANSMITTAL_CREATE.SUCCESS, payload })
    yield call(jobSiteTransmittalsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_TRANSMITTAL_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteTransmittal() {
  yield takeLatest(constants.JOB_SITE_TRANSMITTAL_CREATE.ACTION, sagaCreateJobSiteTransmittal)
}

function* sagaUpdateJobSiteTransmittal(action) {
  try {
    const payload = {
      transmittal_id: action.transmittalId,
      transmittal_data: {
        description: action.content.description,
        attention: action.content.attention,
        status: action.content.status,
        job_id: action.jobId,
        created_by_id: action.userId,
        updated_by_id: action.userId,
        sending_other_text: action.content.sending_other_text,
        transmitted_other_text: action.content.transmitted_other_text
      },
      sending_list: action.sending,
      transmittal_items: action.transmittalItems,
      transmitted_list: action.transmitted
    }

    yield call(api.updateJobSiteTransmittal, payload)
    yield put({ type: constants.JOB_SITE_TRANSMITTAL_UPDATE.SUCCESS, payload })
    yield call(jobSiteTransmittalsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_TRANSMITTAL_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteTransmittal() {
  yield takeLatest(constants.JOB_SITE_TRANSMITTAL_UPDATE.ACTION, sagaUpdateJobSiteTransmittal)
}

function* sagaDeleteJobSiteTransmittal(action) {
  try {
    const payload = {
      transmittal_id: action.transmittalId
    }
    yield call(api.deleteJobSiteTransmittal, action.transmittalId)
    yield put({ type: constants.JOB_SITE_TRANSMITTAL_DELETE.SUCCESS, payload })
    yield call(jobSiteTransmittalsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_TRANSMITTAL_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSiteTransmittal() {
  yield takeLatest(constants.JOB_SITE_TRANSMITTAL_DELETE.ACTION, sagaDeleteJobSiteTransmittal)
}

function* getTransmittalData(action) {
  try {
    const payload = yield call(api.getTransmittalData, action.transmittalId)
    yield put({ type: constants.GET_TRANSMITTAL_DATA.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_TRANSMITTAL_DATA.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTransmittalData() {
  yield takeLatest(constants.GET_TRANSMITTAL_DATA.ACTION, getTransmittalData)
}

function* uploadTransmittalAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      transmittalId: action.transmittalId
    }

    yield call(api.uploadTransmittalAttachments, payload)
    yield put({ type: constants.UPLOAD_TRANSMITTAL_ATTACHMENT.SUCCESS, payload })
    yield call(getTransmittalAttachments, { transmittalId: action.transmittalId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_TRANSMITTAL_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadTransmittalAttachments() {
  yield takeLatest(constants.UPLOAD_TRANSMITTAL_ATTACHMENT.ACTION, uploadTransmittalAttachments)
}

function* getTransmittalAttachments(action) {
  try {
    const payload = yield call(api.getTransmittalAttachments, action.transmittalId)
    yield put({ type: constants.GET_TRANSMITTAL_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_TRANSMITTAL_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetTransmittalAttachments() {
  yield takeLatest(constants.GET_TRANSMITTAL_ATTACHMENTS.ACTION, getTransmittalAttachments)
}

function* updateTransmittalAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_TRANSMITTAL_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getTransmittalAttachments, { transmittalId: action.transmittalId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_TRANSMITTAL_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateTransmittalAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_TRANSMITTAL_ATTACHMENT_DESCRIPTION.ACTION,
    updateTransmittalAttachmentDescription
  )
}

function* deleteTransmittalAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      transmittalId: action.transmittalId
    }

    yield call(api.deleteTransmittalAttachment, payload)
    yield put({ type: constants.DELETE_TRANSMITTAL_ATTACHMENT.SUCCESS, payload })
    yield call(getTransmittalAttachments, { transmittalId: action.transmittalId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_TRANSMITTAL_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteTransmittalAttachments() {
  yield takeLatest(constants.DELETE_TRANSMITTAL_ATTACHMENT.ACTION, deleteTransmittalAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteTransmittals),

    fork(watchCreateJobSiteTransmittal),
    fork(watchUpdateJobSiteTransmittal),
    fork(watchDeleteJobSiteTransmittal),

    fork(watchUploadTransmittalAttachments),
    fork(watchGetTransmittalAttachments),
    fork(watchUpdateTransmittalAttachmentDescription),
    fork(watchDeleteTransmittalAttachments),

    fork(watchGetTransmittalData)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteTransmittalSaga.js